/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import {
    displayErrorMessage, displaySuccessMessage, getUserIPAddress, clearCookies
} from '@insticator/insticator-ui'; // iui-utils
import { updateAgreement } from 'utils/api/auth';
import { batchActions } from "redux-batched-actions";


/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export const SET_SESSION_DATA = 'SET_SESSION_DATA';
export const STORE_SESSION_DATA = 'STORE_SESSION_DATA';
export const SET_USER_IP = 'SET_USER_IP';
export const RECEIVE_ERRORS = 'RECEIVE_ERRORS';
export const SET_AUTH_DATA = 'SET_AUTH_DATA';
export const SET_AUTH_DATA_FAIL = 'SET_AUTH_DATA_FAIL';
export const SIGN_AGREEMENT = 'SIGN_AGREEMENT';

// ACTIONS USED BY THUNKS TO COMMUNICATE WITH A REDUCER
const setUserIP = ip => ({
	type: SET_USER_IP,
	ip
});

const receiveErrors = errors => ({
    type: RECEIVE_ERRORS,
    errors
});

// ACTIONS THAT CAN BE IMPORTED AND USED IN COMPONENTS
export const setSessionData = sessionData => ({
    type: SET_SESSION_DATA,
    sessionData
});

export const storeSessionData = sessionData => ({
    type: STORE_SESSION_DATA,
    sessionData
});

export const setAuthData = response => ({
    type: SET_AUTH_DATA,
    response
});

export const setAuthDataFail = () => ({
    type: SET_AUTH_DATA_FAIL
});

const signAgreement= () => ({
    type: SIGN_AGREEMENT
});

// THUNKS
export const getUserIP = () => dispatch => (
    getUserIPAddress()
        .then(response => dispatch(setUserIP(JSON.parse(response).ip)),
            err => dispatch(receiveErrors(err)))
);

//Agreement
export const updateAgreementInfo = (agreementUUID, userUUID, callback) => dispatch => (
    updateAgreement(agreementUUID, userUUID)
        .then(() => {
            clearCookies(['show_terms_and_condition', 'agreement_uuid']);
            return dispatch(batchActions([signAgreement(), displaySuccessMessage('You have agreed to our terms!')]))
        })
        .then(() => { if(!!callback && typeof callback === 'function') callback({ success: true }) })

        .catch(() => {
            if(!!callback && typeof callback === 'function') callback({ success: false });
            return dispatch(displayErrorMessage('There was an issue updating your Agreement Information'))
        })
);
